// TODO: Why are we importing random types?
import { IScoringRules } from "@scaleip/nest-api/src/common/types/contacts.type";

// Type definitions
type SeniorityKeysType = "C-suite" | "Director" | "Entry" | "Manager" | "Senior";
type EmailStatusKeysType = "extrapolated" | "unavailable" | "verified";
type TitleScoreKeysType = "common" | "middle" | "other" | "rare";
type MainKeysType = "attendedConference" | "emailStatus" | "seniority" | "titleScore";

// Predefined order for sorting
const predefinedOrder = {
  emailStatus: ["verified", "extrapolated", "unavailable"] as EmailStatusKeysType[],
  mainOrder: ["seniority", "emailStatus", "titleScore", "attendedConference"] as MainKeysType[],
  seniority: ["Director", "Senior", "C-suite", "Manager", "Entry"] as SeniorityKeysType[],
  titleScore: ["rare", "middle", "common", "other"] as TitleScoreKeysType[],
};

// Sort slider objects by predefined order
const sortObject = <T extends string>(object: Record<T, number>, order: T[]): Record<T, number> => {
  const sortedObject = {} as Record<T, number>;
  for (const key of order) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      sortedObject[key] = object[key];
    }
  }
  return sortedObject;
};

// Function used to sort nested object to keep sliders in predefined order
// because we are storing rules as a json inside of SQL database, and we want to keep the order of sliders
// and postgresql does not guarantee the order of keys in json
export const sortNestedObject = (object: Partial<IScoringRules>): IScoringRules => {
  const sortedObject = {} as IScoringRules;

  for (const key of predefinedOrder.mainOrder) {
    if (key === "seniority" && object.seniority) {
      sortedObject.seniority = sortObject(object.seniority, predefinedOrder.seniority);
    } else if (key === "emailStatus" && object.emailStatus) {
      sortedObject.emailStatus = sortObject(object.emailStatus, predefinedOrder.emailStatus);
    } else if (key === "titleScore" && object.titleScore) {
      sortedObject.titleScore = sortObject(object.titleScore, predefinedOrder.titleScore);
    } else if (key === "attendedConference" && object.attendedConference !== undefined) {
      sortedObject.attendedConference = object.attendedConference;
    }
  }

  return sortedObject;
};
